import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { appEnv } from '../config/app-env';

export function apiBaseUrlInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  // Only prefix relative URLs.
  if (/^https?:\/\//i.test(req.url) || req.url.startsWith('assets/') || req.url.startsWith('/assets/')) {
    return next(req);
  }

  const url = `${appEnv.apiBaseUrl.replace(/\/+$/, '')}/${req.url.replace(/^\/+/, '')}`;
  return next(req.clone({ url }));
}

